import { selector } from '@/lib/selectors';
import type { RoutingState } from '@/domain/router/types';

// The company the user is in: the one the URL names; null on a route that names none. The one
// exception is the redirect entry point, which puts in scope the company its link names before
// it navigates, while the URL is still the redirect's.
export const currentCompanyIdSelector = selector<unknown, string | null>(
  (state) => state.routing,
  (r: RoutingState) => r.get('companyId'),
);
